import { Component, OnInit, Inject, Optional} from '@angular/core';
import { MAT_DIALOG_DATA} from '@angular/material';

declare var $: any;

@Component({
  selector: 'app-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.scss']
})
export class PreviewDialogComponent implements OnInit {

  public src: string;

  constructor(
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any
        ) {

    this.src = data.src;
  }

  ngOnInit() {
  }
}
